// The MyJarvis brand logo ships as a committed static asset under public/logos/
// so every tenant is self-contained — no runtime dependency on an external R2
// bucket (MJOS-170/172).
export const myjarvisLogoUrl = "/logos/logo_jarvis_dark.svg";
